export enum UserType {
  User = 'user',
  ChatBot = 'chat_bot',
}

export enum FormType {
  Text = 'text',
  RichText = 'rich_text',
  HeadText = 'head_text',
  ImgText = 'img_text',
  Link = 'link',
  Button = 'button',
}

export interface Request {
  id: number;
  uuid: string;
  text: string;
}

export interface Conversation {
  id: number;
  userType: UserType,
  outList: Output[];
}

export interface Response {
  id: number;
  uuid: string;
  output: Output[];
}

export interface Output {
  expression_form: FormType;
  text: string;
  content_attribute: string;
  file_id?: any;
  action_class: string;
}
